import React from 'react';

import Header from '../../../Layout/Header';
import FooterComponent from '../../../Layout/Footer';
import banner from '../../../Assets/Linkages/CapacityBuilding/Capacity-Building-Banner.jpg';
import '../../../Styles/Linkages&Outreach.css';
import '../../../Styles/CapacityBuilding.css';
import CapacityBuildingIntroduction from './CapacityBuildingIntroduction';
import CapacityBuildingEvents from './CapacityBuildingEvents';

const CapacityBuildingPage = () => (
  <>
    <Header />
    <main className="capacity-building-page">
      <section className="outreach-event-hero" aria-label="Capacity Building Workshops and Forums">
        <img
          src={banner}
          alt="Capacity Building Workshops and Trainings"
        />
      </section>
      <CapacityBuildingIntroduction />
      <CapacityBuildingEvents />
    </main>
    <FooterComponent />
  </>
);

export default CapacityBuildingPage;
